export default angular.module('directive.userAuthDirective', [])
	.directive('userAuthDirective', function () {
		var controller = [ '$rootScope', '$scope', '$http', '$timeout', '$resource', '$location', 'MenuConstant', 'UserInfoConstant', 'permissionList', 'permissions', '$mdSidenav', '$state', '$cookies', '$stateParams', '$localStorage', 'GlobalSrv', 'ngNotify', '$interval',
			function ($rootScope, $scope, $http, $timeout, $resource, $location, MenuConstant, UserInfoConstant, permissionList, permissions, $mdSidenav, $state, $cookies, $stateParams, $localStorage, GlobalSrv, ngNotify, $interval) {
				console.log('Por aqui pase yo!')

				var localenv = require('../../local.env.json')

				if (localenv.USER_API_URL != false) {
					var url = localenv.USER_API_URL + '/api/user-api'
					var serverUrl = localenv.SERVER_NAME + 'app' + $state.current.url

					$cookies.remove('hasDemand')
					$cookies.remove('hasType')
					$cookies.remove('groupids')

					var protocol = $location.protocol()
					
					if (protocol == 'http') {
						$cookies.put('ESTSAUTH_INTIAL', 'true')
					}

					var ESTSAUTH = $cookies.get('ESTSAUTH_INTIAL')

					if ((typeof ESTSAUTH === 'undefined' || ESTSAUTH == 'false') && protocol == 'https') {
						//  $cookies.put('ESTSAUTH_INTIAL',true)
						window.location = url

						return
					} else {
						if (localenv.loginType == 'web') {
							wsdlFunctionCallback()
						} else if (localenv.loginType == 'saml' || localenv.loginType == 'adal') {
							samlFunctionCallback()
						} else {
							casAdalFunctionCallback()
						}
					}
				} else {
					$scope.admin = userSettingDefault.user
					UserInfoConstant[0].details.push(userSettingDefault)
					permissions.setPermissions(userSettingDefault.user.permissions[0])
					$scope.subitems = MenuConstant[0].menu
				}

				var flag = true

				function casAdalFunctionCallback() {
					$.ajax({
						dataType: 'jsonp',
						data    : 'returnTo=' + serverUrl,
						jsonp   : 'callback',
						url     : url,
						cache   : true,
						async   : true,
						headers : {
							'Access-Control-Allow-Origin' : '*',
							'Access-Control-Allow-Methods': 'GET,OPTIONS',
							'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
							'Content-Type'                : 'text/plain',
							'Accept-Language'             : 'en-US',
						},
						xhrFields: {
							withCredentials: true,
						},
						crossDomain: true,
						success    : function (response) {
							var temp = JSON.parse(decodeURIComponent(atob(response).split('').map(function (c) {
								return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
							}).join('')))

							response = temp
							setResponseData(response)
						},
						error: function (xhr, ajaxOptions, thrownError) {
							window.location = url
							console.log(thrownError)
						},
					})
				}

				function samlFunctionCallback() {
					var searchObject = $location.search().idUserToken

					if (typeof searchObject !== 'undefined') {
						var temp = JSON.parse(decodeURIComponent(atob(searchObject).split('').map(function (c) {
							return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
						}).join('')))

						console.log(temp)

						GlobalSrv.getUserInfo.POST(temp).$promise.then((response) => {
							var data = response.data

							if (response.status == 1) {
								$localStorage.userLogin = data
								$location.search('idUserToken', null)

								if (typeof data === 'undefined') {
									window.location = url
								} else {
									setResponseData(data)
								}
							} else {
								//  $cookies.remove('userLogin');
								delete $localStorage.userLogin
								// window.location = url;
							}
						}).catch((error) => {
							window.location = url
						})
					} else {
						var cookieObject = $localStorage.userLogin

						if (typeof cookieObject === 'undefined') {
							window.location = url
						} else {
							setResponseData(cookieObject)
						}
					}
				}

				function wsdlFunctionCallback() {
					const cookieObject = $localStorage.userAuth
					let autoLogin = $localStorage.autoLogin

					if (autoLogin) {
						try {
							autoLogin = decodeURIComponent(escape(window.atob(autoLogin)))
							var email = autoLogin

							delete $localStorage.autoLogin
							var param = {
								users: {},
								type : 'autoLogin',
							}

							param['users'] = {
								sn       : email,
								givenname: email,
								name     : email,
								mail     : email,
							}

							GlobalSrv.getUserInfoMetta.POST(param).$promise.then((response) => {
								if (response.status == 1) {
									const data = Helpers.getUserStored(response.data)

									$localStorage.userLogin = data
									$localStorage.userAuth = response.data
									$localStorage.logintime = Date.now()
									window.location = LOCAL_ENV_CONSTANT.HOMEPAGE
								} else {
									delete $localStorage.userLogin
									delete $localStorage.userAuth
								}
							}).catch(() => {
								window.location = url + '?returnTo=' + serverUrl
							})
						} catch (e) {
							delete $localStorage.userLogin
							delete $localStorage.userAuth
							window.location = LOCAL_ENV_CONSTANT.HOMEPAGE
						}
					} else if (typeof cookieObject === 'undefined') {
						$state.go('login')
					} else {
						setResponseData(Helpers.getUserStored(cookieObject))
					}
				}

				function setResponseData(cookieObject) {
					var response = cookieObject

					$scope.admin = response.user
					$rootScope.admin = response.user
					$localStorage.userLogin = response
					$cookies.put('token', response.token)
					UserInfoConstant[0].details.push(response)
					permissions.setPermissions(response.user.permissions[0])
					$timeout(() => {
						$rootScope.urlAllowed = UserInfoConstant[0].details[0].user['url']
						$rootScope.subitems = MenuConstant[0].menu
						$rootScope.urlImage = response.user.picture

						console.log(response.user.picture)
						$rootScope.defaultImage = require('../images/unknown.png')
					}, 200)
				}
			} ]

		// var template ='';
		return {
			restrict: 'EA', //Default in 1.3+
			scope   : {
				datasource: '=',
				add       : '&', //,
				// WORKSPACEID:'@workspaceid',
				// REPORTID:'@reportid'
			},
			controller: controller,
			// template: template
		}
	})
	.name




// WEBPACK FOOTER //
// ./src/services/userAuth.directive.js